import $ from "jquery";
import { LinksTransform } from "../eldmlTransform/LinksTransform";
import { ActionButtonsTransform } from "../eldmlTransform/ActionButtonsTransform";
import { ImagesTransform } from "../eldmlTransform/ImagesTransform";
import { TableTransform } from "../eldmlTransform/TableTransform";
import { HrTransform } from "../eldmlTransform/HrTransform";
import { MarginsTransform } from "../eldmlTransform/MarginsTransform";
import { FontSizesTransform } from "../eldmlTransform/FontSizesTransform";
import { LineSpaceTransform } from "../eldmlTransform/LineSpaceTransform";
import { VerticalTransform } from "../eldmlTransform/VerticalTransform";
import { AvatarTransform } from "../eldmlTransform/AvatarTransform";
import { PdfTransform } from "../eldmlTransform/PdfTransform";
import { VideoTransform } from "../eldmlTransform/VideoTransform";
import { ProgressbarTransform } from "../eldmlTransform/ProgressbarTransform";
import { SpreadsheetTransform } from "../eldmlTransform/SpreadsheetTransform";
import { IconTransform } from "../eldmlTransform/IconTransform";
import { ProcessTransform } from "../eldmlTransform/ProcessTransform";
import { EldmlTransformerHelper } from "../eldmlTransform/EldmlTransformerHelper";
import { GroupTransform } from "../eldmlTransform/GroupTransform";
import { TruncateTransform } from "../eldmlTransform/TruncateTransform";
import { RenderTransform } from "../eldmlTransform/RenderTransform";
import { DoclinkTransform } from "../eldmlTransform/DoclinkTransform";
import { FileTransform } from "../eldmlTransform/FileTransform";

export const transformEldml = (
  container: HTMLElement,
  transformer: EldmlTransformerHelper,
) => {
  // zabezpieczenie przed kolejnym wykonaniem konwersji
  let selector = transformer.force
    ? $(container)
    : $(container).filter(":not(.eldml-transformed)");

  selector.addClass("eldml-transformed");

  // dla mob inaczej
  if (transformer.mobile) {
    // tu jest asynchroniczność na mob
    // truncate musi być jako pierwsze, bo generuje html, który musi być transformowany
    const transform = new TruncateTransform(selector, transformer);
    transform.apply().then(() => processTransformations(selector, transformer));
  } else {
    processTransformations(selector, transformer);
  }
};

export const generateInitialsAvatar = (
  initials: string,
  color: string = "#ddd",
  size: number,
) => {
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const context = canvas.getContext("2d");
  if (!context) return undefined;

  context.fillStyle = color;
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.font = canvas.width / 2 + "px Arial";
  context.textAlign = "center";
  context.fillStyle = "#FFF";
  context.fillText(initials, canvas.width / 2, canvas.height / 1.48);
  return canvas.toDataURL();
};

const processTransformations = (
  selector: JQuery<HTMLElement>,
  transformer: EldmlTransformerHelper,
) => {
  const transformations = [
    new DoclinkTransform(selector, transformer),
    new FileTransform(selector, transformer),
    new RenderTransform(selector, transformer),
    new LinksTransform(selector, transformer),
    new ActionButtonsTransform(selector, transformer),
    new ImagesTransform(selector, transformer),
    new TableTransform(selector, transformer),
    new HrTransform(selector, transformer),
    new MarginsTransform(selector, transformer),
    new FontSizesTransform(selector, transformer),
    new LineSpaceTransform(selector, transformer),
    new VerticalTransform(selector, transformer),
    new AvatarTransform(selector, transformer),
    new PdfTransform(selector, transformer),
    new VideoTransform(selector, transformer),
    new ProgressbarTransform(selector, transformer),
    new SpreadsheetTransform(selector, transformer),
    new IconTransform(selector, transformer),
    new ProcessTransform(selector, transformer),
    new GroupTransform(selector, transformer),
  ];

  transformations.forEach((transformation) => transformation.apply());
};
